export const WEB_TRACKING_DETAILS_FLAGS = {
  enableWebTrackingUICashlessPOD: 0,
  enableWebTrackingStayContactable: 1,
};

export const isSet = (flags, feature) =>
  // eslint-disable-next-line no-bitwise
  (flags & (1 << feature)) !== 0;

export default {};
